<template>
  <div>
    <iframe ref="vimeoPlayer" :src="videoUrl" width="640" height="360" frameborder="0" allowfullscreen></iframe>
  </div>
</template>

<script>
import Player from "@vimeo/player";

export default {
  name: "VimeoPlayer",
  props: {
    videoId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      player: null,
      videoUrl: `https://player.vimeo.com/video/${this.videoId}?muted=1&background=1&loop=1&autopause=0&badge=0&amp;player_id=0&amp;app_id=58479`,
    };
  },
  mounted() {
    this.initializePlayer();

    // We listen to the resize event
    window.addEventListener("resize", () => {
      // let vw = window.innerWidth
      // console.log('resizing overhere', vw)
      this.shouldIplay(window.innerWidth);
    });

    this.shouldIplay(window.innerWidth);
  },
  methods: {
    shouldIplay(width) {
      if (width <= 991) {
        this.playVideo();
      } else {
        this.pauseVideo();
      }
      //   this.pauseVideo();
    },

    initializePlayer() {
      this.player = new Player(this.$refs.vimeoPlayer);

      // Optionally, add event listeners
      this.player.on("play", () => {
        // console.log('Video is playing');
      });
      this.player.on("pause", () => {
        // console.log('Video is paused');
      });

      //   this.pauseVideo();
    },
    playVideo() {
      this.player
        .play()
        .then(() => {
          // console.log('The video started to play');
        })
        .catch((error) => {
          console.error("Failed to play the video:", error);
        });
    },
    pauseVideo() {
      this.player
        .pause()
        .then(() => {
          // console.log('The video is paused');
        })
        .catch((error) => {
          console.error("Failed to pause the video:", error);
        });
    },
  },
};
</script>
